import { createContext, useContext, useEffect, useState } from "react";
import { api, hasBackend } from "./api";
import { DEFAULT_CONTENT, mergeDeep } from "./content";
import { useSeo } from "../seo/useSeo";

const Ctx = createContext({ content: DEFAULT_CONTENT, setContent: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  useEffect(() => {
    if (!hasBackend) return undefined;
    let live = true;
    api
      .get("/content")
      .then((r) => {
        if (live && r.data?.data) setContent(mergeDeep(DEFAULT_CONTENT, r.data.data));
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, []);
  return <Ctx.Provider value={{ content, setContent }}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);

export const IntroCtx = createContext(true);
export const useIntroReady = () => useContext(IntroCtx);

export const useMeta = (path) => useSeo(path);
